module.exports = {
  'app.ad.validate.url': 'Vui lòng nhập đúng định dạng liên kết url'
}